import Parse from 'parse';

const AdminModule = {
  namespaced: true,
  state: {
    roles: [],
    users: [],
    userOptions: [],
    userVacation: [],
    userExtraVacations: [],
    usersMandatoryVacation: [],
    usersInvalidForMandatoryVacation: [],
  },
  mutations: {
    setUsers(state, users) {
      state.users = users;
    },
    setUserVacation(state, userVacation) {
      state.userVacation = userVacation;
    },
    updateUser(state, updatedUser) {
      const ind = state.users.findIndex((el) => el.id === updatedUser.id);
      state.users.splice(ind, 1, updatedUser);
    },
    deleteUserVacation(state, id) {
      const i = state.userVacation.findIndex((el) => el.id === id);
      state.userVacation.splice(i, 1);
    },
    resetUserVacation(state) {
      state.userVacation = [];
    },
    setUserExtraVacations(state, s) {
      state.userExtraVacations = s;
    },
    addUserExtraVacation(state, s) {
      state.userExtraVacations.unshift(s);
    },
    resetUserExtraDays(state) {
      state.userExtraVacations = [];
    },
    setRoles(state, roles) {
      state.roles = roles;
    },
    setUserOptions(state, userOptions) {
      state.userOptions = userOptions;
    },
    addUser(state, user) {
      state.users.push(user);
    },
    setUsersMandatoryVacation(state, validUsers) {
      state.usersMandatoryVacation = validUsers;
    },
    setUsersInvalidForMandatoryVacation(state, invalidUsers) {
      state.usersInvalidForMandatoryVacation = invalidUsers;
    },
  },
  actions: {
    async loadUsers({ commit }) {
      try {
        const roleQuery = new Parse.Query(Parse.Role);
        roleQuery.ascending('name');
        const roles = await roleQuery.find(null);
        commit('setRoles', roles);

        const userObj = {};
        for (const role of roles) {
          const allMembers = await role.relation('users').query().limit(1000).find(null);

          for (let i = 0; i < allMembers.length; i++) {
            let employee = allMembers[i].get('employeeId');
            if (employee in userObj) userObj[employee].roles.push(role.get('name'));
            else {
              allMembers[i].roles = [role.get('name')];
              userObj[employee] = allMembers[i];
            }
          }
        }
        const users = Object.values(userObj);
        users.sort((a, b) => a.get('employeeId') - b.get('employeeId'));

        const uo = [];
        for (let i = 0; i < users.length; i++) {
          const u = users[i];
          uo.push({
            name: `${u.get('firstname')} ${u.get('lastname')} (${u.get('employeeId')})`,
            value: u.id,
          });
        }
        commit('setUserOptions', uo);
        commit('setUsers', users);
      } catch (e) {
        console.log(e);
      }
    },
    async loadUserVacation({ commit }, user) {
      try {
        const query = new Parse.Query('VacationRequest');
        query.equalTo('user', user);
        query.addDescending('createdAt');
        const requests = await query.find(null);
        commit('setUserVacation', requests);
      } catch (e) {
        console.log(e);
      }
    },
    async deleteVacationRequest({ commit }, id) {
      try {
        await Parse.Cloud.run('deleteVacationRequest', { id }, {});
        commit('deleteUserVacation', id);
      } catch (e) {
        console.log(e);
      }
    },
    // eslint-disable-next-line no-empty-pattern
    async cancelVacationRequest({}, id) {
      try {
        await Parse.Cloud.run('cancelVacationRequest', { id }, {});
      } catch (e) {
        console.log(e);
      }
    },
    async loadUserExtraVacations({ commit }, user) {
      try {
        const query = new Parse.Query('ExtraVacationDays');
        query.equalTo('user', user);
        query.addDescending('createdAt');
        const requests = await query.find(null);
        commit('setUserExtraVacations', requests);
      } catch (e) {
        console.log(e);
      }
    },
    async addNewUserExtraVacation({ commit }, payload) {
      try {
        let obj = new Parse.Object('ExtraVacationDays');
        obj = await obj.save(payload, null);
        commit('addUserExtraVacation', obj);
      } catch (error) {
        console.log(error);
      }
    },
    async addUser({ commit }, userData) {
      const user = await Parse.Cloud.run('createUser', { userData }, {});
      commit('addUser', user);
    },
    async updateUser({ commit }, { user, cUser }) {
      const updatedUser = await Parse.Cloud.run('updateUser', { user, cUserId: cUser.id }, {});
      commit('updateUser', updatedUser);
    },
    async getUsersForMandatoryVacation({ state, commit }, { vacationDates, calendarEventDates, groups }) {
      const vacationStartDate = new Date(vacationDates[0]);
      const vacationEndDate = new Date(vacationDates[vacationDates.length - 1]);
      const vacationQuery = new Parse.Query('VacationRequest');
      vacationQuery.limit(16000);
      vacationQuery.greaterThanOrEqualTo('requestFrom', vacationStartDate);
      vacationQuery.lessThanOrEqualTo('requestTo', vacationEndDate);

      const calendarEventQuery = new Parse.Query('CalendarEvent');
      calendarEventQuery.limit(60000);
      calendarEventQuery.containedIn('day', calendarEventDates);

      let possibleUsers;
      if (groups.length === 1) {
        possibleUsers = state.users.filter((user) => {
          return groups[0] === 'SoKa-Bau'
            ? user.get('isActive') && user.get('vacationType') === groups[0]
            : user.get('isActive') && user.get('vacationType') !== 'SoKa-Bau';
        });
      } else {
        possibleUsers = state.users.filter((user) => user.get('isActive'));
      }
      const validUsers = [];
      const invalidUsers = [];
      let found;

      try {
        const vacationDays = await vacationQuery.find();
        const eventDays = await calendarEventQuery.find();

        possibleUsers.forEach((user) => {
          found = false;

          for (let vac of vacationDays)
            if (vac.get('user').id === user.id) {
              invalidUsers.push(user);
              found = true;
              break;
            }

          if (!found)
            for (let event of eventDays)
              if (event.get('user').id === user.id) {
                invalidUsers.push(user);
                found = true;
                break;
              }

          if (!found) validUsers.push(user);
        });

        commit('setUsersMandatoryVacation', validUsers);
        commit('setUsersInvalidForMandatoryVacation', invalidUsers);
      } catch (err) {
        console.log(err);
      }
    },
    async setMandatoryVacationForAllValidUsers({ state /*,commit*/ }, { vacationDates }) {
      const vacationStartDate = new Date(vacationDates[0]);
      const vacationEndDate = new Date(vacationDates[vacationDates.length - 1]);
      try {
        const days = vacationDates.map((d) => {
          return {
            date: {
              __type: 'Date',
              iso: new Date(d).toISOString(),
            },
            value: 1,
          };
        });
        if (days.length === 2 && days[0].date.iso === days[1].date.iso) days.pop();

        for (const user of state.usersMandatoryVacation) {
          const vacationRequest = new Parse.Object('VacationRequest');
          const userPointer = new Parse.Object('_User');
          userPointer.id = user.id;
          vacationRequest.set('user', userPointer);
          vacationRequest.set('isAdmin', true);
          vacationRequest.set('requestFrom', vacationStartDate);
          vacationRequest.set('requestTo', vacationEndDate);
          vacationRequest.set('status', 'accepted');
          vacationRequest.set('days', days);
          await vacationRequest.save();
        }
        return 'done';
      } catch (err) {
        console.log(err);
        return err;
      }
    },
    removeMandatoryVacation({ state }) {
      state.usersMandatoryVacation = [];
      state.usersInvalidForMandatoryVacation = [];
    },
    async changeRoles({ state, commit }, { user, roleChanges }) {
      try {
        for (const roleName in roleChanges) {
          const addOrRemove = roleChanges[roleName] ? 'add' : 'remove';
          const role = state.roles.find((r) => r.get('name') === roleName);
          role.getUsers()[addOrRemove](user);
          await role.save();
        }
        for (const roleName in roleChanges)
          if (roleChanges[roleName]) user.roles.push(roleName);
          else user.roles = user.roles.filter((r) => r !== roleName);
        commit('updateUser', user);
      } catch (err) {
        console.log(err);
      }
    },
    async loadTeamUsers({ commit }, teamChef) {
      /*
      The code below was supposed to allow another member of the workingGroup other than the chef to grant
      vacation, but the required column 'canAlsoGrantVacation' is missing in the table 'WorkingGroup',
      causing a bug with getting all employees of the workingGroup. For example in admin/employee-year-calendar.

      const chefQuery = new Parse.Query('WorkingGroup');
      chefQuery.equalTo('chef', teamChef);
      const canAlsoGrantVacationQuery = new Parse.Query('WorkingGroup');
      canAlsoGrantVacationQuery.equalTo('canAlsoGrantVacation', teamChef);
      const query = Parse.Query.or(chefQuery, canAlsoGrantVacationQuery);
      */
      const query = new Parse.Query('WorkingGroup');
      query.equalTo('chef', teamChef);
      query.include('users');
      query.limit(1000);
      try {
        const groups = await query.find();
        const teamUsers = [];
        groups.forEach((group) =>
          group
            .get('users')
            .filter((user) => user.get('isActive'))
            .map((user) => {
              if (!teamUsers.map((teamUser) => teamUser.id).includes(user.id)) teamUsers.push(user);
            })
        );
        teamUsers.sort((a, b) => a.get('employeeId') - b.get('employeeId'));
        commit('setUsers', teamUsers);
      } catch (err) {
        console.log(err.message);
      }
    },
  },
  getters: {
    users: (state) => state.users,
    roles: (state) => state.roles,
    tagesberichtUsers: (state) => state.users.filter((el) => el.get('hasTagesbericht') && el.get('isActive')),
    userVacation: (state) => state.userVacation,
    userExtraVacations: (state) => state.userExtraVacations,
    userOptions: (state) => state.userOptions,
    usersMandatoryVacation: (state) => state.usersMandatoryVacation,
    usersInvalidForMandatoryVacation: (state) => state.usersInvalidForMandatoryVacation,
  },
};

export default AdminModule;
